<app-survey-status-button
  [status]="displaySurveyStatus(data)"
  [hasOngoingUpload]="data.hasOngoingValidateSurvey"
  [hasFailedUpload]="data.hasFailedValidateSurvey"
  (click)="
    data.surveyStatus == surveyStatus.OutsidePending ||
    data.surveyStatus == surveyStatus.InsidePending
      ? onStartSurvey(data)
      : onGoToSurvey(data)
  "
>
</app-survey-status-button>
<mat-icon class="material-icons ongoing-icon" *ngIf="data.hasOngoingValidateSurvey">autorenew</mat-icon>
<mat-icon class="material-icons failed-icon" *ngIf="data.hasFailedValidateSurvey">error_outline</mat-icon>
<mat-icon class="material-icons succeeded-icon" *ngIf="data.hasSucceededValidateSurvey">check</mat-icon>
<div class="expand">
  <span class="bold">
    ({{ (allSurveys | BuildingId: data.buildingId).length }})
  </span>
  <span (click)="data.isCollapsed = !data.isCollapsed">
    <img
      class="collapsible-icon"
      [class.open]="!data.isCollapsed"
      src="assets/icon-expand.svg"
      alt="expand/collapse"
    />
  </span>
</div>
